import { useMutation, useQueryClient } from "@tanstack/react-query";
import { useContext } from "react";
import { AlertsContext } from "providers/alerts";
import { apiRequest } from "utils/api";
import { getErrorMessage } from "utils/errorHandler";

export const useLoanActions = () => {
  const queryClient = useQueryClient();
  const { showError } = useContext(AlertsContext);

  const applyChanges = useMutation({
    mutationFn: async (data: any): Promise<void> => {
      const response = await apiRequest("/supabase/loans/update", data);

      if (!response) {
        throw new Error("Failed to update loan");
      }
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["loan"], exact: false });
      queryClient.invalidateQueries({ queryKey: ["loans"], exact: false });
      queryClient.invalidateQueries({ queryKey: ["loan-interest-balances"], exact: false });
    },
    onError: error => {
      showError({
        title: "Error",
        description: getErrorMessage(error),
      });
    },
  });

  return { applyChanges };
};
